import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { ReviewThanks } from '@components/ReviewThanks';
import { ShafaLoader } from '@ui/ShafaLoader';

import { useHasNextReviewRequestQuery } from './graphql.v4.generated';

type RouteParams = {
  threadId: string;
};

type Props = {
  className?: string;
};

export const ReviewThanksContainer: React.FC<Props> = ({ className }) => {
  const params = useParams<RouteParams | null>();
  const { data, loading } = useHasNextReviewRequestQuery({ context: { v4: true } });
  const nextReviewRequest = data?.viewer?.reviewRequests?.edges
    .find((edge) => edge?.node?.threadId !== params?.threadId);
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  if (loading) {
    return (
      <ShafaLoader
        delay={400}
        in={true}
      />
    );
  }

  return (
    <ReviewThanks
      nextReviewRequest={nextReviewRequest?.node}
      publishingTimeInfo={!!query.get('publishingTimeInfo')}
      className={className}
    />
  );
};
